import { BannerDto, BannerDtoImpl } from './bannerdto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class BannerBuilder
{
    constructor(private bannersList: any)
    {
        if(bannersList.banners === undefined)
        {
            throw new NoDataException("Banner data doesnt exists");
        }
    }

    buildAll(): BannerDto[]
    {
        return this.parseGetBannerDetailsResponse();
    }
    
    private parseGetBannerDetailsResponse(): BannerDto[]
    {
        let listOfBanners: BannerDto[] = [];
        
        let bannerDetailsResponse = null;
        this.bannersList.banners.forEach((bannerJson: any, index: number) =>
        {
            bannerDetailsResponse = new BannerDtoImpl();
            bannerDetailsResponse.setId(index);
            bannerDetailsResponse.setLanguage(bannerJson.language);
            bannerDetailsResponse.setImgPath(bannerJson.bannerPath);
            bannerDetailsResponse.setType(bannerJson.type);
            bannerDetailsResponse.setSearchKey(bannerJson.searchKey);
            bannerDetailsResponse.setBannerOrder(bannerJson.bannerOrder);
            
            listOfBanners.push(bannerDetailsResponse);
        });
        return listOfBanners;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/banner/bannerbuilder.ts